import React, { useContext } from 'react';
import { CurrencyLabel } from '../../../../common/inputs';
import { ViewButton } from '../../../../common/containers/button';
import Utility from "../../../../supply-chain/utils/DateParser";
import entityContext from "../../../../../context/entityContext";
import authService from "../../../../../services/authService";

const InvoicesTable = ({
  invoices,
  selectedTransactions,
  onSelect,
  onShowAttachments,
  handleSelectAll,
  MAX_SELECTABLE,
  selProduct
}) => {

  const { ParseDateDMY } = Utility();

  const { constants } = authService.getCurrentUser();
  const { SUPPLYCHAIN, TRADEFINANCE, INVOICE } = constants.PRODUCTS;

  // Use product constants directly as keys
  const PRODUCT_LABEL_MAP = {
    [SUPPLYCHAIN]: "Supplier",
    [TRADEFINANCE]: "Supplier",
    [INVOICE]: "Debtor",
  };

  // Default fallback is "Supplier"
  const getContactLabel = (product) => PRODUCT_LABEL_MAP[product] || "Supplier";

  return(
    <>
      <div className='fixed-height-div'>
        <table className="table text-secondary table-sm">
          <thead style={{position:"sticky", top:0, backgroundColor: "#fff", zIndex:999}}>
            <tr className="text-left">
              {/* <th style={{ width: 36 }} /> */}
              <th >
                <div className="custom-control d-flex custom-checkbox small">
                  <input
                    id="selectAllInvoices"
                    type="checkbox"
                    className="custom-control-input"
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    checked={selectedTransactions.length > 0 && selectedTransactions.length >= Math.min(invoices.length, MAX_SELECTABLE)}
                  />
                  <label className="custom-control-label" htmlFor="selectAllInvoices" />
                </div>
              </th>
                <th>Inv No...</th>
                <th>Date</th>
                <th>Due date</th>
                <th>{ getContactLabel(selProduct) }</th>
                <th>Amount</th>
                <th><i className='fa fa-paperclip font-weight-bold'></i></th>
              </tr>
            </thead>
            <tbody>
              {invoices.map((invoice) => (
                <tr key={invoice.ref_id} className="text-left">
                  <td>
                    <div className="custom-control d-flex custom-checkbox small">
                      <input
                        id={invoice.ref_id}
                        type="checkbox"
                        className="custom-control-input"
                        onChange={(e) => onSelect(e.target.checked, invoice.ref_id)}
                        checked={selectedTransactions.some((t) => t.ref_id === invoice.ref_id)}
                      />
                      <label className="custom-control-label" htmlFor={invoice.ref_id} />
                    </div>
                  </td>
                  <td>{invoice.inv_number}</td>
                  <td>{invoice.date ? ParseDateDMY(invoice.date) : null}</td>
                  <td>{invoice.dueDate ? ParseDateDMY(invoice.dueDate) : null}</td>
                  <td>{invoice.supplier}</td>
                  <td>
                    <CurrencyLabel value={invoice.amount} />
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-sm p-0 text-secondary"
                      onClick={() => onShowAttachments(invoice.ref_id)}
                      aria-label={`View attachments for invoice ${invoice.inv_number}`}
                    >
                      <ViewButton />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className='text-xs text-left sticky-footer text-danger mt-2' >Select invoices from the list above, then submit them for funding (up to 10 at a time).</div>
      </>
    );
}

export default InvoicesTable;
